export default () => ({
  titleBar: {
    display: 'flex',
    justifyContent: 'space-between',
    background: '#D3D3D3',
  },
  header: {
    padding: '5px',
    margin: '5px',
  },
  table: {
    display: 'grid',
    grid: '50px / 200px 200px',
  },
});
